import sdl from '@jds/react-generated-sdl/JDSSearchResults';
import type { JDSSearchResultsProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, SearchResultsProps } from '../logic';

const Component = (props: SearchResultsProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    appearance = 'normal',
    open = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { appearance, open, ...rest },
    'JDSSearchResults',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SearchResults = withLogic(Component) as React.FC<SearchResultsProps> & {
  slotName?: string;
};

SearchResults.displayName = 'SearchResults';
SearchResults.slotName = 'jds_search_results';

export { SearchResults, type JDSSearchResultsProps };
